import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class IdRouteResolver implements Resolve<string> {

  constructor() {
  }

  resolve(route: ActivatedRouteSnapshot) {
    return route.paramMap.get('id');
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/historique-modifications/filtres/id-route.resolver.ts